(()=>{

  const CLASSNAME_SELECTOR = {
    INLINE_FILTER: ".product-grid-2-inline-filters__wrapper",
    PANEL_TRIGGER: ".product-grid-2-inline-filters__panel-trigger",
    PANEL_TRIGGER_ACTIVE: ".product-grid-2-inline-filters__panel-trigger--active",
    PANEL: ".product-grid-2-inline-filters__panel",
    PANEL_ACTIVE: ".product-grid-2-inline-filters__panel--active",
    VIEW_MORE: ".main-collection-2-inline-filters__view-more"
  }

  function handlePanelChange(event) {
    const targetEl = event.detail?.data.targetEl;
    if (!targetEl) return;
    
    const wrapper = targetEl.closest(".product-grid-2-inline-filters__wrapper");
    const targetPanelId = targetEl.dataset.name;
    const targetPanelEl = wrapper.querySelector(`${CLASSNAME_SELECTOR.PANEL}[data-name="${targetPanelId}"]`);
    const activeTriggerPanelEl = wrapper.querySelector(CLASSNAME_SELECTOR.PANEL_TRIGGER_ACTIVE);
    const activePanelEl = wrapper.querySelector(CLASSNAME_SELECTOR.PANEL_ACTIVE);

    activeTriggerPanelEl.classList.remove(`${CLASSNAME_SELECTOR.PANEL_TRIGGER_ACTIVE.split(".")[1]}`);
    activePanelEl.classList.remove(`${CLASSNAME_SELECTOR.PANEL_ACTIVE.split(".")[1]}`);
    targetEl.classList.add(`${CLASSNAME_SELECTOR.PANEL_TRIGGER_ACTIVE.split(".")[1]}`);
    targetPanelEl.classList.add(`${CLASSNAME_SELECTOR.PANEL_ACTIVE.split(".")[1]}`);
  };

  function handleInlineFilterVisibility(event){
    let productsCount = event.detail.data.productsCount;

    if (productsCount == null){
      productsCount = document.getElementById("product-grid").querySelectorAll('.product-card-2__wrapper')?.length;
    }

    if (productsCount != null){
      const inlineFilters = document.querySelectorAll('.product-grid-2-inline-filters__wrapper.product-grid-2-inline-filters__wrapper--hidden');
      inlineFilters.forEach(inlineFilterEl => {
        const position = Number(inlineFilterEl.dataset.position);
        const columnCount = window.innerWidth > 1023 ? 4: 2;

        const unhide = position * columnCount < productsCount;

        // console.log("handle inline filter", position * columnCount, productsCount);

        if (unhide){
          inlineFilterEl.style.display = "grid";
          inlineFilterEl.classList.remove("product-grid-2-inline-filters__wrapper--hidden");
        };
      })
    }
  }

  function handleViewMoreBtnClick(event){
    const id = event?.detail?.data?.id;
    if (id){
      document.dispatchEvent(new CustomEvent('main-collection-2:filter-drawer:open'));
      const detailElement = document.getElementById(id)
      if (detailElement){
        detailElement.open = "true";
        requestAnimationFrame(() => {
          detailElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        });
      }
    }
  }

  document.addEventListener("main-collection-2:inline-filter-panel:change", handlePanelChange);
  document.addEventListener('main-collection-2:inline-filter-visibility:update', handleInlineFilterVisibility);
  document.addEventListener('main-collection-2:inline-filter:view-more-btn-click', handleViewMoreBtnClick);
})();